/**
 * Lib.Common: Progress display component declarations
 */


import ibProgressCircular   from './ib-progress-circular.vue';
import ibProgressDots       from './ib-progress-dots.vue';
import ibProgressLinear     from './ib-progress-linear.vue';
import ibWaitSpin           from './ib-wait-spin.vue';


export default [
    ibProgressCircular,
    ibProgressDots,
    ibProgressLinear,
    ibWaitSpin
];
